import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Network from './Requests';
import {
  addBreadcrumbs,
  clearList,
  levelDecrement,
  levelIncrement,
  removeBreadcrumbs,
  setCompany,
  setNeedUpdate,
  setParentStructureId,
  setTemplateAdd,
  setTemplateList,
  setTemplateSelection,
  templateOpenStatus,
  setSaveVariant,
  setIdAccess,
  setCountUser,
} from '../store/reducers/projectSlice';
import { setLoader } from '../store/reducers/preloaderSlice';
import defaultImg from '../images/def_chat.png';
import AddingProjectTemplate from './AddingProjectTemplate';
import axios from 'axios';
import { globalConfig } from '../configuration/config';
import arrowWin from '../images/arrow_win.png';
import { useTranslation } from "react-i18next";

export default function TemplateProject(props) {
  const { t } = useTranslation();

  const [show, setShow] = React.useState(false);
  const [selectedUsersFolder, setSelectedUsersFolder] = React.useState(false);
  const [selectedPartnersFolder, setSelectedPartnersFolder] = React.useState(false);
  const [selectedRelatedPartnersFolder, setSelectedRelatedPartnersFolder] = React.useState(false);
  const dispatch = useDispatch();
  const openStatus = useSelector((state) => state.project.templateStatusOpen);
  const templateList = useSelector((state) => state.project.templateList);
  const prevParentStructureId = useSelector((state) => state.project.currentParentStructureId);
  const breadcrumbsList = useSelector((state) => state.project.breadcrumbs);
  const levelCatalog = useSelector((state) => state.project.levelCatalog);
  const needUpdate = useSelector((state) => state.project.needUpdate);
  const templateSelect = useSelector((state) => state.project.templateSelect);
  const templateAdd = useSelector((state) => state.project.templateAdd);
  const [allCompanies, setAllCompanies] = React.useState({});
  const company = useSelector((state) => state.project.companyId);
  const [selectedCompany, setSelectedCompany] = React.useState({});
  const [lastSelectedCompanyId, setLastSelectedCompany] = React.useState(0)
  const currentVariant = useSelector((state) => state?.variant?.current?.calculationGuid);
  const saveProjectGuid = useSelector((state) => state?.guids?.project);
  const userGuid = useSelector((state) => state?.guids?.userGuid);
  const idAccess = useSelector((state) => state?.project?.idAccess);
  const [users, setUsers] = React.useState([]);
  const [partners, setPartners] = React.useState([]);
  const [searchResult, setSearchResult] = React.useState([]);
  const [searchingFlag, setSearchingFlag] = React.useState(false);
  let searchTimer;
  let timer = 0;
  const [firstTimeOpened, setFirstTimeOpened] = React.useState(true);

  const closeCatalog = () => {
    dispatch(templateOpenStatus(false));
  };

  const searchInCatalog = async (searchText) => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      if (searchText) {
        try {
          await axios
            .get(
              `${globalConfig.config.common.api}Calculation/SearchCalculations?searchString=${searchText}`,
              { withCredentials: true },
            )
            .then((res) => {
              setSearchResult(res.data);
              setSearchingFlag(true);
            });
        } catch (error) {
          console.log('error', error);
        }
      } else {
        setSearchingFlag(false);
        setSearchResult([]);
      }
    }, 500);
  };

  const openUsersFolder = async () => {
    setSelectedPartnersFolder(false);
    setSelectedRelatedPartnersFolder(false);

    await axios
      .get(`${globalConfig.config.common.api}Users/GetAll?IdParentStructure=${selectedCompany.id}&idCompany=${selectedCompany.id}`, {
        withCredentials: true,
      })
      .then((res) => {
        setUsers(res.data);
      });

    setSelectedUsersFolder(true);
  };

  const openPartnersFolder = async () => {
    setSelectedUsersFolder(false);
    setSelectedRelatedPartnersFolder(false);

    await axios
      .get(
        `${globalConfig.config.common.api}CompanyRelations/GetRelations?idOwnerCompany=${selectedCompany.id}&idRelationType=1`,
        { withCredentials: true },
      )
      .then((res) => {
        const partnersData = res.data.map((partner) => {
          const details = allCompanies.find((company) => company.id === partner.idRelatedCompany);
          return {
            ...partner,
            ...(details ? { name: details.name } : {}),
          };
        });
        setPartners(partnersData);
        console.log('partners', partners);
      });

    setSelectedPartnersFolder(true);
  };

  const openRelatedPartnersFolder = async () => {
    setSelectedUsersFolder(false);
    setSelectedPartnersFolder(false);

    await axios
      .get(
        `${globalConfig.config.common.api}CompanyRelations/GetRelations?idRelatedCompany=${selectedCompany.id}&idRelationType=1`,
        { withCredentials: true },
      )
      .then((res) => {
        const partnersData = res.data.map((partner) => {
          const details = allCompanies.find((company) => company.id === partner.idOwnerCompany);
          return {
            ...partner,
            ...(details ? { name: details.name } : {}),
          };
        });
        setPartners(partnersData);
      });

    setSelectedRelatedPartnersFolder(true);
  };

  const next = async (idCompany, id, name, guid, baseCalculationGuid, isAllChats, idAccess) => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      if (id > 0 && company > 0 && idAccess == null) {
        dispatch(setParentStructureId(id));
        dispatch(addBreadcrumbs({ name: name, id: id, idAccess: idAccess }));
        dispatch(levelIncrement());
      } else if (id == 0 && isAllChats == true && guid == null && idAccess == null) {
        dispatch(setParentStructureId(id));
        dispatch(addBreadcrumbs({ name: name, id: id }));
        dispatch(levelIncrement());
      } else if (id == 0 && isAllChats == true && guid.length > 0 && idAccess == null) {
        dispatch(setTemplateSelection(guid));
        const project = await new Network().GetBaseProject(guid);
        props.setCurrentProject(project);
      } else if (idAccess > 0) {
        dispatch(setParentStructureId(id));
        dispatch(setIdAccess(idAccess));
        dispatch(addBreadcrumbs({ name: name, id: id, idAccess: idAccess }));
        dispatch(levelIncrement());
      } else {
        dispatch(setTemplateAdd(baseCalculationGuid));
        const data = await new Network().getUsersProject(guid);
        dispatch(setCountUser(data?.length));
        new Network()
          .AddDisplayTape(baseCalculationGuid, guid, userGuid, company)
          .then((result) => {
            props.onAddProject(result, true, false, null, [], false);
            dispatch(setTemplateSelection(guid));
          });
      }
    }, 50);
  };

  const back = async (prevParentStructureId) => {
    if (selectedUsersFolder || selectedPartnersFolder || selectedRelatedPartnersFolder) {
      setSelectedUsersFolder(false);
      setSelectedPartnersFolder(false);
      setSelectedRelatedPartnersFolder(false);
    } else if (breadcrumbsList.length == 1) {
      dispatch(templateOpenStatus(false));
    } else if (breadcrumbsList.length > 1) {
      dispatch(removeBreadcrumbs());
      dispatch(levelDecrement());
      dispatch(setParentStructureId(breadcrumbsList[breadcrumbsList.length - 2].id));
      dispatch(setIdAccess(breadcrumbsList[breadcrumbsList.length - 2].idAccess));
    }
  };

  useEffect(() => {
    let structure = [];
    getCompanies();
    getAvailabeCompanies();

    const fetch = async () => {
      if (breadcrumbsList.length == 1) {
        if (company != 'null' && company > 0) {
          structure = await new Network().GetCatalog(company, '', true, idAccess);
          if (firstTimeOpened) {
            next(
              company.id,
              structure[0].id,
              structure[0].name,
              structure[0].guid,
              structure[0].baseCalculationGuid,
              structure[0].isAllChats,
              structure[0].idAccess,
            )
            setFirstTimeOpened(false)
          }
        }
      } else {
        console.warn('test');
        if (lastSelectedCompanyId != company) {
          setLastSelectedCompany(company)
          structure = await new Network().GetCatalog(company);
          dispatch(removeBreadcrumbs());
          next(
            company.id,
            structure[0].id,
            structure[0].name,
            structure[0].guid,
            structure[0].baseCalculationGuid,
            structure[0].isAllChats,
            structure[0].idAccess,
          )
        }
        else {
          structure = await new Network().GetCatalog(company, prevParentStructureId, true, idAccess);
        }
      }
      dispatch(setTemplateList(structure));
      dispatch(setNeedUpdate(false));
      // dispatch(setCompany(storageCompany?.id));
    };

    fetch();
  }, [needUpdate, breadcrumbsList, company, props.displayTape]);

  const getCompanies = async () => {
    setAllCompanies(await new Network().GetCompanies());
  };

  const getAvailabeCompanies = async () => {
    const companies = await new Network().GetUserCompanies();

    if (companies) {
      setSelectedCompany(companies.find((company) => company.id == companyId));
    }
  };

  /////////////////////////
  const [anchorEl, setAnchorEl] = React.useState(null);
  const companyId = useSelector((state) => state?.project?.companyId);
  const projectUnite = useSelector((state) => state?.project?.list);
  const saveVariant = useSelector((state) => state?.project?.saveVariant);

  const handleClick = (event) => {
    projectUnite.length > 0 ? setAnchorEl(event.currentTarget) : dispatch(templateOpenStatus(true));
  };

  const handleClickClose = (event) => {
    if (projectUnite.length > 0) {
      setAnchorEl(event.currentTarget);
    } else {
      dispatch(templateOpenStatus(false));
      dispatch(removeBreadcrumbs());
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const saveProject = async (
    name,
    number,
    address,
    fullName,
    phone,
    clientEmail,
    amoLink,
    source,
    productType,
    sum,
    requestDate,
    orderDate,
    expirationDate,
    orderCompletionDate,
    archivedDate,
    feedback,
    descr,
    workCosts,
    materialCosts,
    costsNote,
  ) => {
    if (saveVariant) {
      dispatch(setLoader(true));
      const send = new Network()
        .AddVariant(currentVariant, saveProjectGuid, name)
        .then((result) => {
          props.onAddProject([], false, true, saveProjectGuid);
          dispatch(clearList());
          let com = companyId;
          props.changeCatalog(false);
          dispatch(setCompany(com));
          setShow(false);
          dispatch(setSaveVariant(false));
          var cusid_ele = document.getElementsByClassName('projects');
          cusid_ele[0].classList.toggle('active');
          var cusid_ele = document.getElementsByClassName('open-project');
          cusid_ele[0].classList.toggle('active');
          dispatch(setLoader(false));
        });
    } else {
      dispatch(setLoader(true));
      new Network()
        .addUserProject(
          name,
          descr,
          companyId,
          templateAdd,
          true,
          number,
          address,
          fullName,
          phone,
          clientEmail,
          amoLink,
          source,
          productType,
          sum,
          new Date(requestDate),
          new Date(orderDate),
          new Date(expirationDate),
          new Date(orderCompletionDate),
          new Date(archivedDate),
          feedback,
          workCosts,
          materialCosts,
          costsNote,
        )
        .then((result) => {
          new Network().getUsersProject(result.projectGuid).then((res) => {
            result.users = res;
          });
          props.onAddProject(result);
          props.changeCatalog(false);
          dispatch(clearList());
          let com = companyId;
          dispatch(setCompany(com));
          setShow(false);
          dispatch(setLoader(false));
          var cusid_ele = document.getElementsByClassName('projects');
          cusid_ele[0].classList.toggle('active');
          var cusid_ele = document.getElementsByClassName('open-project');
          cusid_ele[0].classList.toggle('active');
        });
    }
  };

  /////////////////////////

  return (
    <div className={openStatus == true ? 'template-projects active' : 'template-projects'}>
      <div onClick={closeCatalog} class="close-catalog">
        <div class="img-close" />
      </div>
      <div className="project-breadcrumbs">
        {breadcrumbsList.length > 0 && <div className="breadcrumb-back" onClick={back}></div>}
        <div className="breadcrumb-title">
          {breadcrumbsList.length > 0 &&
            breadcrumbsList.slice(-2).map((breadcrumb, index) => {
              return (
                <div key={breadcrumb?.id || index}>
                  {breadcrumb.name == t("templateProject.category")
                    ? selectedCompany?.name
                    : breadcrumb.name}/
                  {selectedUsersFolder ? t("templateProject.users") : ''}
                  {selectedPartnersFolder ? t("templateProject.ourDealers") : ''}
                  {selectedRelatedPartnersFolder ? t("templateProject.weAreDealers") : ''}
                </div>
              );
            })}
        </div>
      </div>
      {!selectedUsersFolder &&
        !selectedPartnersFolder &&
        !selectedRelatedPartnersFolder && (
          <input
            type="text"
            placeholder={t("templateProject.search")}
            onChange={(event) => searchInCatalog(event.target.value)}
            class="search-input"
          />
        )}
      <div class="template-projects-wrapper">
        {!selectedUsersFolder &&
        !selectedPartnersFolder &&
        !selectedRelatedPartnersFolder &&
        !searchingFlag &&
        templateList?.map((template) => {
          return (
            <div
              className={
                templateSelect === template.guid
                  ? 'template-projects-item active'
                  : 'template-projects-item'
              }
              data-id={template.guid}
              onClick={() =>                
                next(
                  template.idCompany,
                  template.id,
                  template.name,
                  template.guid,
                  template.baseCalculationGuid,
                  template.isAllChats,
                  template.idAccess,
                )
              }
              onDoubleClick={(e) => {
                if (templateSelect === '') {
                  alert(t("templateProject.selectVariant"));
                  return false;
                }
                if (currentVariant == null) {
                  alert(t("templateProject.selectVariant"));
                  return false;
                }
                clearTimeout(timer);
                setShow(true);
              }}>
              <div
                className="template-projects-item--img"
                style={{
                  backgroundImage: `url(${
                    template.iconPath ? template.iconPath.replace(/ /gi, '%20') : defaultImg
                  })`,
                }}>
                {template.idOriginal && template.idOriginal !== '' && (
                  <img
                    src={arrowWin}
                    alt="Arrow Icon"
                    style={{
                      position: 'absolute',
                      bottom: '5px',
                      left: '5px',
                      width: '24px',
                      height: '24px',
                    }}
                  />
                )}
              </div>

              {template.isAccess && <div className="idAccess"></div>}
              <div className="template-projects-item--name">{template.name}</div>
              {template?.idOriginal && <div className="template-label"></div>}
            </div>
          );
        })}
      </div>

      {!selectedUsersFolder &&
      !selectedPartnersFolder &&
      !selectedRelatedPartnersFolder &&
      !searchingFlag &&
      templateList[0]?.name == t("templateProject.catalog") && (
        <div class="catalog-main-directories">
          <div onClick={openUsersFolder} class="template-projects-item">
            <div class="img-users" />
            <div className="template-projects-item--name">{t("templateProject.users")}</div>
          </div>
          <div onClick={openPartnersFolder} class="template-projects-item">
            <div class="img-building" style={{ width: 40, marginRight: 45 }} />
            <div className="template-projects-item--name">{t("templateProject.ourDealers")}</div>
          </div>
          <div onClick={openRelatedPartnersFolder} class="template-projects-item">
            <div class="img-building" style={{ width: 40, marginRight: 45 }} />
            <div className="template-projects-item--name">{t("templateProject.weAreDealers")}</div>
          </div>
        </div>
      )}

      {/* Пользователи */}
      {selectedUsersFolder &&
        <div class="selected-directory">
          {selectedUsersFolder &&
            users.map((user) => (
              <div class="template-projects-item">
                <div class="img-user" style={{ width: 40, marginRight: 45 }} />
                <div className="template-projects-item--name">
                  {user.lastName} {user.name}
                </div>
              </div>
            ))}
          {selectedUsersFolder && users.length == 0 && (
            <div class="nothing-found">
              <div class="img-empty" />
              <div>{t("templateProject.nothingFound")}</div>
            </div>
          )}
        </div>
      }

      {/* Партнёры */}
      {(selectedRelatedPartnersFolder || selectedPartnersFolder) &&
        <div class="selected-directory">
          {(selectedRelatedPartnersFolder || selectedPartnersFolder) &&
            partners.map((partner) => (
              <div class="template-projects-item">
                <div class="img-building" style={{ width: 40, marginRight: 45 }} />
                <div className="template-projects-item--name">{partner.name}</div>
              </div>
            ))}
          {(selectedRelatedPartnersFolder || selectedPartnersFolder) && partners.length == 0 && (
            <div class="nothing-found">
              <div class="img-empty" />
              <div>{t("templateProject.nothingFound")}</div>
            </div>
          )}
        </div>
      }

      {/* Результаты поиска */}
      {searchingFlag &&
        <div class="selected-directory search-result">
          {searchingFlag &&
            searchResult.map((item) => (
              <div 
                className={
                  templateSelect === item.guid
                    ? 'template-projects-item active'
                    : 'template-projects-item'
                }
                onClick={(e) => {
                  if (templateSelect === '') {
                    alert(t("templateProject.selectVariant"));
                    return false;
                  }
                  if (currentVariant == null) {
                    alert(t("templateProject.selectVariant"));
                    return false;
                  }
                  clearTimeout(timer);
                  setShow(true);
                }}
              >
                <div
                  className="template-projects-item--img"
                  style={{
                    backgroundImage: `url(${
                      item.pathKey ? `https://storage.yandexcloud.net/system123.render.lab/${item.pathKey.replace(/ /gi, '%20')}/main_icon.jpg` : defaultImg
                    })`,
                  }}
                />
                <div className="template-projects-item--name">{item.name}</div>
              </div>
            ))}

          {searchingFlag && searchResult.length == 0 && (
            <div class="nothing-found">
              <div class="img-empty" />
              <div>{t("templateProject.nothingFound")}</div>
            </div>
          )}
        </div>
      }

      <AddingProjectTemplate show={show} close={handleClose} save={saveProject} />
    </div>
  );
}
